import { Loader, Logo } from "@/components/lib";
import recruitingImage from "@/images/recruiting.png";
import axios from "axios";
import { useState } from "react";

export default function Recruiting() {
  const [loading, setLoading] = useState(false);

  const download = async () => {
    const url = "/api/utility/download";
    setLoading(true);
    try {
      const res = await axios.get(url, { responseType: "blob" });
      const blob = new Blob([res.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "January-2025.xlsx";
      link.click();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex flex-col text-center text-white">
      <Logo className="w-48 lg:w-64 mx-auto my-5 sm:mt-0 lg:hidden" />
      <div className="relative w-full overflow-hidden shadow-lg pb-4">
        <img
          src={recruitingImage}
          alt="Grapevine High School"
          className="w-full h-[70vh] lg:h-[90vh] opacity-20"
        />

        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(7, 16, 27, 0) 18.3%, #07101B 100%)"
          }}
        />

        <div className="absolute bottom-0 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 p-2 text-white w-full">
          <p className="font-bold text-2xl lg:text-7xl">
            Grapevine High School
          </p>
          <p className="font-bold mt-2 text-xl lg:text-6xl">
            Recruiting Database
          </p>
          <button
            onClick={download}
            className="mt-10 mx-auto bg-[#CF2027] px-2 py-2 lg:px-6 lg:py-3 h-fit rounded-full text-lg lg:text-xl w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 flex justify-center items-center gap-4 hover:bg-[#CF202790] transition-colors"
          >
            Download
            {loading && <Loader />}
          </button>
        </div>
      </div>
    </main>
  );
}
